import { Detail } from "@/components/Detail/Detail";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { loadInitialData } from "./util";

window.addEventListener("DOMContentLoaded", () => {
  loadInitialData("detail", (data, domNode) => {
    const { item, sections } = data;
    hydrateRoot(
      domNode,
      <StrictMode>
        <Detail item={item} sections={sections} />
      </StrictMode>
    );
  });
});
